import { API_LOAD_STATUS } from "constants/labels";

export const initialState = {
  accountLookup: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Data: {
      Exists: false,
      AccountNumber: "",
    },
  },
  profileInfo: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Data: {
      HomePhone: null,
      MobileNumber: null,
      WorkPhone: null,
      ServiceOn: false,
      HeatingAccount: null,
      CustomerName: null,
      SecondaryName: null,
      ServiceAddress: null,
    },
  },
  energyUsage: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Data: {
      EnergyUsageDetails_Res: null,
      CustomerName: null,
      ServiceAddress: null,
    },
  },
  currentBilling: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Data: {
      asOfDate: null,
      amountDue: null,
      dueDate: null,
      pastDue: null,
    },
  },
  grantInfo: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Data: {
      CaseNumber: null,
      HeatingSeason: null,
      PovertyLevel: null,
      ResumeEnrolled: null,
      GrantTransactions: null,
    },
  },
  billingAndPaymentHistory: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Data: {
      BillingHistory_Res: {
        LegacyBillDates: null,
      },
      PaymentHistory_Res: {
        PaymentDetails_Res: null,
      },
    },
  },
  reconnect: {
    Load: {
      status: "",
      message: null,
      errors: [],
    },
    Data: [],
  },
  emergencyHold: {
    isLoaded: false,
    Message: "",
    Data: {
      Status: "",
      Message: "",
      AccountNumber: "",
    },
  },
  emergencyHoldStatus: {
    isLoaded: false,
    Message: "",
    Data: {
      Jurisdiction: "",
      EmergencyHoldDetail: null,
      PledgeAmountDetail: null,
      OtherPledgesByAgency: null,
    },
  },
  energyUsageReport: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Data: [],
  },
  accountBalanceReport: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Data: [],
  },
  billPaymentPDF: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Data: {
      BillDate: "",
      DocContent: "",
      SapErrors: [],
    },
  },
  currentBillPDF: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Data: {
      BillDate: "",
      DocContent: "",
      SapErrors: [],
    },
  },
  manageSeason: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Data: [],
  },
  reportSampleFile: {
    Data: [],
  },
  agencies: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Data: [],
  },
  grantReport: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Message: "",
    Data: {
      publishedDate: "",
      Message: "",
      outstandingGrants: []
    },
  },
  tooltipMsgs: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Succeeded: false,
    Data: [],
  },
  reconnectionRequestReport: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Data: [],
  },
  pledgeAmountReport: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Data: [],
  },
  emergencyHoldReport: {
    Load: {
      status: API_LOAD_STATUS.PENDING,
      message: "",
      errors: [],
    },
    Data: [],
  },
};
